import React from 'react';
import './Class.css';
import coding from '../../Images/Tech Gurukul.png';
import {Helmet} from "react-helmet";

const Coding = () => (
  <div className="explore-container">
    <Helmet>
                <meta charSet="utf-8" />
                <title>Tech Gurukul - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
    {/* Back Button */}
    <button className="back-button" onClick={() => window.history.back()}>
      ← Back
    </button>

    {/* Lakshya Card (Right Side, Above Header) */}
    <div className="lakshya-card">
      <img
        src={coding} 
        loading="lazy"
        alt="coding"
        className="lakshya-image"
      />
      <div className="course-details">
  
      <p className="pricing">
  💼 Fees for Full Course: ₹ 2999/-
  <br />
</p>

  <a href="https://rzp.io/rzp/Tech-Gurukul" target="_blank" rel="noopener noreferrer">
    <button className="buy-button">Buy Now</button>
  </a>
</div>

    </div>

    {/* Lakshya Header (Full Width) */}
    <div className="lakshya-header">
      <div className="lakshya-header-content">
        <h2 className="lakshya-title">Tech-<span className='highlight'>Gurukul</span> (Class-<span className='highlight'>6-10</span>)</h2>
      </div>
    </div>

    {/* Batch Details Section */}
    <div className="batch-details">
      <h3>Description</h3>
      <ul>
  <li><strong>1️⃣Learn Popular Programming Languages</strong>  
    <ul>
      <li>💻Python, JavaScript, C++, HTML/CSS, and more.
      </li>
    </ul>
  </li>
  <li><strong>2️⃣Real-World Projects</strong>  
    <ul>
      <li>🧩Students will build their own websites, games, and applications.
      </li>
    </ul>
  </li>
  <li><strong>3️⃣Interactive Learning</strong>  
    <ul>
      <li>🎮Gamified coding challenges, quizzes, and contests for a fun and competitive learning environment.
      </li>
    </ul>
  </li>
  <li><strong>4️⃣Regular Tests & Assessments</strong>  
    <ul>
      <li>📝Weekly quizzes and tests to assess the learning and improvement of students.
      </li>
    </ul>
  </li>
  <li><strong>5️⃣Exposure to Robotics & AI</strong>  
    <ul>
      <li>🤖Understand the basics of robotics and artificial intelligence (AI) to prepare for future tech advancements.</li>
    </ul>
  </li>
  <li><strong>6️⃣Expert Guidence</strong>  
    <ul>
      <li>👨‍🏫Learn from experienced tech educators who are passionate about coding and technology.
      </li>
    </ul>
  </li>
  <li><strong>7️⃣Personalized Attention</strong>  
    <ul>
      <li>🧑‍💻Small batch sizes ensure each student gets individualized attention and guidance.
      </li>
    </ul>
  </li>
  <li><strong>8️⃣Live Coding Sessions</strong>  
    <ul>
      <li>💻Real-time interactive coding lessons where students code alongside the instructor.
      </li>
    </ul>
  </li>
  <li><strong>9️⃣24/7 Doubt Solving</strong>  
    <ul>
      <li>🧑‍💻Our team is available around the clock to assist with any questions or challenges faced while learning.</li>
    </ul>
  </li>
  <li><strong>🔟Reward & Recognition</strong>  
    <ul>
      <li>🏆Students will receive badges and certificates for outstanding performance and project completion.</li>
    </ul>
  </li>
  <li><strong>📩 Have Questions?</strong>  
    <ul>
      <li>Reach out to us at <a href="mailto:support@ottertutors.com">support@ottertutors.com</a></li>
    </ul>
  </li>
  <br/>
  <li><strong>🚀 Join <span className='highlight1'>'Tech-Gurukul'</span> Take the first step towards academic success!</strong>  
  </li>
</ul>


    </div>

    {/* FAQ Section */}
    <div className="faq-section">
      <h2>FAQs</h2>
      <p style={{ textAlign: 'center' }}>
  Here are some of the frequently asked questions:
</p>
<div className="faq-grid">
  <div className="faq-item">
    🎯
    <div>
      <h3>Who Should Join This Batch?</h3>
      <p>
      🎓 Tech Gurukul is designed for Class 6-10 students who are interested in learning coding, programming, and developing skills for a tech-driven future.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Where Will the Classes Be Held?</h3>
      <p>
        💻 Classes will be conducted on Zoom, and links will be shared via WhatsApp groups for easy access.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>What Programming Languages Will My Child Learn?</h3>
      <p>
      💡 Students will learn popular languages like Python, JavaScript, C++, HTML/CSS, and others, giving them a strong foundation in coding.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>What If My Child Misses a Class?</h3>
      <p>
      📼 Don’t worry! All classes are recorded, so you can watch them later to catch up on any missed content.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>How Are Assessments Handled?</h3>
      <p>
      📝 There will be weekly tests and coding challenges to track the progress of the students. Performance will be assessed, and feedback will be provided to help improve skills.      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Can My Child Work on Real Projects?</h3>
      <p>
      🎮 Yes! Students will work on real-world projects, including websites, games, and apps, ensuring practical learning alongside theory.      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>What Happens If My Child Has Doubts?</h3>
      <p>
      💬 24/7 doubt-solving support is available for students. They can reach out anytime for assistance from instructors and tech mentors.      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Will My Child Learn Robotics or AI?</h3>
      <p>
      🤖 Yes! As part of the program, students will be introduced to robotics and artificial intelligence (AI) concepts to expand their knowledge of cutting-edge technologies.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Can I Get a Refund After Batch Purchase?</h3>
      <p>
      💡 Refunds are not available after batch purchase, as we invest heavily in providing the best learning experience. Please make a thoughtful decision before joining.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>How Can I Track My Child's Progress?</h3>
      <p>
      📈 Regular assessments, personalized feedback, and project-based learning will help track your child's progress and achievements throughout the course.      </p>
    </div>
  </div>
</div>
</div>
  </div>
);

export default Coding;
